module.exports = __webpack_public_path__ + "static/media/wd10.50cba713.jpeg";